import {
  FormControlLabel,
  FormGroup,
  Switch,
  SwitchProps,
  Typography,
  styled,
} from '@mui/material';

interface SwitchButtonComponentProps {
  toggleSwitchState: boolean;
  onToggle: (newState: boolean) => void;
  disableLabel?: boolean;
}

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: 'rgba(36, 73, 252, 1)',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },

    '&.Mui-disabled .MuiSwitch-thumb': {
      color: 'rgba(135, 135, 135, 1)',
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    width: 16,
    height: 16,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: 'rgba(135, 135, 135, 1)',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const SwitchButtonComponent: React.FC<SwitchButtonComponentProps> = ({
  toggleSwitchState,
  onToggle,
  disableLabel,
}: SwitchButtonComponentProps) => {
  const handleToggle = () => {
    const newState = !toggleSwitchState;
    onToggle(newState);
  };

  return (
    <div
      style={{
        width: disableLabel ? '43px' : '70px',
        height: '20px',
        margin: disableLabel ? '0px' : '2px 20px 2px 20px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: disableLabel ? 'flex-end' : 'space-around',
      }}
    >
      <FormGroup>
        <FormControlLabel
          onChange={handleToggle}
          control={<IOSSwitch checked={toggleSwitchState} />}
          label={
            !disableLabel && (
              <Typography
                sx={{
                  ml: '12px',
                  fontFamily: 'Schibsted Grotesk',
                  fontWeight: 500,
                  fontSize: '16px',
                  color: 'rgba(24, 24, 24, 1)',
                }}
              >
                {toggleSwitchState ? 'On' : 'Off'}
              </Typography>
            )
          }
          sx={{
            marginRight: disableLabel ? 0 : '20px',
          }}
        />
      </FormGroup>
    </div>
  );
};

export default SwitchButtonComponent;
